import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7f2be929&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2be929')) {
      api.createRecord('7f2be929', component.options)
    } else {
      api.reload('7f2be929', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=7f2be929&", function () {
      api.rerender('7f2be929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Quotations/Index.vue"
export default component.exports